import { render } from "./MenuManage.vue?vue&type=template&id=3e1554dc&scoped=true"
import script from "./MenuManage.vue?vue&type=script&lang=js"
export * from "./MenuManage.vue?vue&type=script&lang=js"

import "./MenuManage.vue?vue&type=style&index=0&id=3e1554dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e1554dc"]])

export default __exports__